import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container p-5 mx-auto md:w-3/5 w-11/12 border-2 border-fuchsia-600" }
const _hoisted_2 = { class: "text-4xl mb-8 border-b-2 border-fuchsia-600 pb-3" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-3xl text-center mb-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("お知らせ")
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "text-sm m-auto mx-3" }
const _hoisted_10 = {
  key: 0,
  class: "text-sm mx-3 m-auto text-center inline-block rounded-lg p-3 py-1 bg-blue-400 text-white"
}
const _hoisted_11 = {
  key: 1,
  class: "text-sm mx-3 m-auto text-center inline-block rounded-lg p-3 py-1 bg-pink-400 text-white"
}
const _hoisted_12 = {
  key: 2,
  class: "text-sm mx-3 m-auto text-center inline-block rounded-lg p-3 py-1 bg-yellow-400 text-white"
}
const _hoisted_13 = { class: "text-md title mx-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createVNode(_component_fa, { icon: "users" }),
          _hoisted_5
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announce_data, (announce) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "text-xl",
              key: announce.id
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announce_data, (announce) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "text-xl",
                      key: announce.id
                    }, [
                      _createElementVNode("li", _hoisted_7, [
                        _createElementVNode("a", {
                          href: announce.url,
                          class: "flex flex-wrap"
                        }, [
                          _createElementVNode("time", _hoisted_9, _toDisplayString(announce.published_at), 1),
                          (announce.Category === 'お知らせ')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, " お知らせ "))
                            : _createCommentVNode("", true),
                          (announce.Category === '運営情報')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 運営情報 "))
                            : _createCommentVNode("", true),
                          (announce.Category === 'メンテナンス')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, " メンテナンス "))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(announce.Title), 1)
                        ], 8, _hoisted_8)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}